import { getKeyTtl, setKeyValueWithTtl } from "./localStorage/localStorage";
const originalFetch = require('isomorphic-fetch');
const fetch = require('fetch-retry')(originalFetch);

async function getAccessTokenFromPassport() {
    let accessToken = getKeyTtl('passportAccessToken') || null;
    
    if (!accessToken) {
        const headers = new Headers();
        headers.append("Content-Type", "application/x-www-form-urlencoded");
    
        const urlEncoded = new URLSearchParams();
        urlEncoded.append("client_id", process.env.REACT_APP_PASSPORT_CLIENT_ID);
        urlEncoded.append("client_secret", process.env.REACT_APP_PASSPORT_CLIENT_SECRET);
        urlEncoded.append("grant_type", process.env.REACT_APP_PASSPORT_GRANT_TYPE);
        urlEncoded.append("username", process.env.REACT_APP_PASSPORT_USERNAME);
        urlEncoded.append("password", process.env.REACT_APP_PASSPORT_PASSWORD);
        urlEncoded.append("scope", process.env.REACT_APP_PASSPORT_SCOPE);

        const requestOptions = {
            method: 'POST',
            headers: headers,
            body: urlEncoded,
          };
    
    
        const passportUrl = `${process.env.REACT_APP_PASSPORT_APP_API_URL}/protocol/openid-connect/token`;
        const response = await fetch(passportUrl, requestOptions);
        const data = await response.json();
        accessToken = data.access_token;
        const ttl = data.expires_in - 600;  // default: 3600 secs -> 1 hour
        setKeyValueWithTtl('passportAccessToken', accessToken, ttl);
    }

    return accessToken;
}

export async function sendConsumerResponse(consumerResponseObj) {
    const access_token = await getAccessTokenFromPassport();

    const url = `${process.env.REACT_APP_API_URL}/v3/consumer-feedback`
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${access_token}`);
    headers.append("Content-Type", 'application/json');
    // make sure we have this field not null
    if (!consumerResponseObj.timestamp) consumerResponseObj.timestamp = Math.floor(new Date().getTime() / 1000);

    return fetch(url, {
        method: 'POST',
        body: JSON.stringify(consumerResponseObj),
        headers: headers
    }).then(response => {
        if (response.ok) {
            return Promise.resolve(response.json());
        } else {
            const error = new Error(response.statusText);
            error.response = response;
            return Promise.reject(error);
        }
    });
}

export async function fetchOrderById(orderId) {
    const access_token = await getAccessTokenFromPassport();
    const url = `${process.env.REACT_APP_API_URL}/v3/transaction-e-receipt/${orderId}`
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${access_token}`);

    return fetch(url, { headers: headers }).then(response => {
        if (response.ok) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    });
}

export async function fetchOrderByTime(timestamp, deviceCode) {
    const access_token = await getAccessTokenFromPassport();

    const url = `${process.env.REACT_APP_API_URL}/v3/transaction-e-receipt?timestamp=${timestamp}&deviceCode=${deviceCode}`
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${access_token}`);

    return fetch(url, {
        headers: headers,
        retries: 8,
        retryOn: [404],
        retryDelay: 7500
    }).then(response => {
        if (response.ok) {
            return Promise.resolve(response.json());
        } else {
            const error = new Error(response.statusText);
            error.response = response;
            return Promise.reject(error);
        }
    });
}

export async function fetchOrgDetails(orgId) {
    const access_token = await getAccessTokenFromPassport();

    const url = `${process.env.REACT_APP_API_URL}/v3/organization/myselfly-settings?organizationId=${orgId}`;
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${access_token}`);

    return fetch(url, { headers: headers }).then(response => {
        if (response.ok) {
            return Promise.resolve(response.json());
        } else {
            const error = new Error(response.statusText);
            error.response = response;
            return Promise.reject(error);
        }
    });
}